import bootstrapI18next from "core/bootstrap/i18next";
import bootstrapBugsnag from "./bugsnag";

export default async function bootstrap() {
  await bootstrapBugsnag();
  await bootstrapI18next();
}
